export class DialogConfig {
    public title: string;
    public message: string;
    public options: DialogOption[];
    public showClose = true;
    public height: string; // i.e. 500px, 20vw
    public width: string;
    // Lay the option buttons out as a vertical list (choose-one prompts with
    // several long labels) instead of the default row.
    public stackOptions = false;
    // Let a click on the backdrop (or Escape) dismiss the dialog, closing it
    // with no option. Off by default: the app-wide MatDialog default is
    // disableClose, so confirmations can't be lost to a stray click.
    public dismissOnBackdrop = false;
    // MatDialog autoFocus override ('dialog' keeps focus on the container so
    // a scanner's Enter cannot press the first button). Default: Material's.
    public autoFocus: 'dialog' | 'first-tabbable' | 'first-heading' | string | boolean;
    constructor() {
        this.options = new Array<DialogOption>();
    }
}

export enum DialogButtonStyle {
    Normal = 1,
    Cancel,
    Confirm,
}

export class DialogOption {
    public name: string;
    public value: any;
    public style: DialogButtonStyle;

    constructor( n: string, v: any, s: DialogButtonStyle ) {
        this.name = n;
        this.value = v;
        this.style = s;
    }
}
